import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './TermsOfService.module.css';

const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.legalPage}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('termsOfService.title')}</h1>
        <p className={styles.lastUpdated}>{t('termsOfService.lastUpdated')}</p>

        <section className={styles.section}>
          <h2>{t('termsOfService.intro.title')}</h2>
          <p>{t('termsOfService.intro.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.intellectualProperty.title')}</h2>
          <p>{t('termsOfService.intellectualProperty.text1')}</p>
          <p>{t('termsOfService.intellectualProperty.text2')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.infringement.title')}</h2>
          <p>{t('termsOfService.infringement.text1')}</p>
          <p>{t('termsOfService.infringement.text2')}</p>
          <p>{t('termsOfService.infringement.text3')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.prohibitedUse.title')}</h2>
          <p>{t('termsOfService.prohibitedUse.text')}</p>
          <ul>
            <li>{t('termsOfService.prohibitedUse.item1')}</li>
            <li>{t('termsOfService.prohibitedUse.item2')}</li>
            <li>{t('termsOfService.prohibitedUse.item3')}</li>
            <li>{t('termsOfService.prohibitedUse.item4')}</li>
            <li>{t('termsOfService.prohibitedUse.item5')}</li>
            <li>{t('termsOfService.prohibitedUse.item6')}</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.contactForm.title')}</h2>
          <p>{t('termsOfService.contactForm.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.contentMAJ.title')}</h2>
          <p>{t('termsOfService.contentMAJ.text1')}</p>
          <p>{t('termsOfService.contentMAJ.text2')}</p>
          <p>{t('termsOfService.contentMAJ.text3')}</p>
          <p>{t('termsOfService.contentMAJ.text4')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.governingLaw.title')}</h2>
          <p>{t('termsOfService.governingLaw.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('termsOfService.contactSection.title')}</h2>
          <p>{t('termsOfService.contactSection.text')}</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
